// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --bg-main: #2e1a46;
    --primary-text: #fff;
    --secondary-text: #19d3c5;
  }
  
  .main {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    gap: 40px;
    width: 100vw;
    height: 100vh;
    background: var(--bg-main);
    background: linear-gradient(
      313deg,
      rgba(46, 26, 70, 1) 9%,
      rgba(46, 26, 70, 1) 60%,
      rgba(2, 156, 142, 1) 100%
    );
  }
  
  @media (max-width: 830px) {
    .main {
      flex-direction: column;
    }
  }
  
  .bg {
    max-width: 700px;
    position: relative;
    display: grid;
    place-items: center;
    aspect-ratio: 1 / 1.1;
    width: 50%;
    /* background-image: url("/404-bg-art.svg"); */
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .img-404 {
    display: block;
    position: absolute;
    top: 50%;
    left: 40%;
    width: 50%;
    height: 50%;
    margin: 0 auto;
    transform: translate(-50%, -50%);
  }
  
  .typography-wrap {
    font-size: 32px;
    font-weight: 800;
    color: var(--primary-text);
    line-height: 4rem;
  }
  
  @media (max-width: 830px) {
    .typography-wrap {
      text-align: center;
    }
  
    .typography-wrap p,
    .typography-wrap span {
      font-size: 14px;
      line-height: 2.5rem;
    }
  }
  
  @media (min-width: 830px) {
    .typography-wrap {
      font-size: 26px;
    }
  
    .typography-wrap p {
      font-size: 20px;
    }
  }
  
  @media (min-width: 960px) {
    .typography-wrap {
      font-size: 32px;
    }
  }
  
  .typography-wrap span {
    color: var(--secondary-text);
  }
  
  .typography-wrap p {
    font-size: 20px;
    font-weight: 200;
  }
  `, "",{"version":3,"sources":["webpack://./src/custom404.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B;;;;;KAKC;EACH;;EAEA;IACE;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;IACV,8CAA8C;IAC9C,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;;MAEE,eAAe;MACf,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;EACF;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB","sourcesContent":[":root {\r\n    --bg-main: #2e1a46;\r\n    --primary-text: #fff;\r\n    --secondary-text: #19d3c5;\r\n  }\r\n  \r\n  .main {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    overflow: hidden;\r\n    gap: 40px;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background: var(--bg-main);\r\n    background: linear-gradient(\r\n      313deg,\r\n      rgba(46, 26, 70, 1) 9%,\r\n      rgba(46, 26, 70, 1) 60%,\r\n      rgba(2, 156, 142, 1) 100%\r\n    );\r\n  }\r\n  \r\n  @media (max-width: 830px) {\r\n    .main {\r\n      flex-direction: column;\r\n    }\r\n  }\r\n  \r\n  .bg {\r\n    max-width: 700px;\r\n    position: relative;\r\n    display: grid;\r\n    place-items: center;\r\n    aspect-ratio: 1 / 1.1;\r\n    width: 50%;\r\n    /* background-image: url(\"/404-bg-art.svg\"); */\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n  }\r\n  \r\n  .img-404 {\r\n    display: block;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 40%;\r\n    width: 50%;\r\n    height: 50%;\r\n    margin: 0 auto;\r\n    transform: translate(-50%, -50%);\r\n  }\r\n  \r\n  .typography-wrap {\r\n    font-size: 32px;\r\n    font-weight: 800;\r\n    color: var(--primary-text);\r\n    line-height: 4rem;\r\n  }\r\n  \r\n  @media (max-width: 830px) {\r\n    .typography-wrap {\r\n      text-align: center;\r\n    }\r\n  \r\n    .typography-wrap p,\r\n    .typography-wrap span {\r\n      font-size: 14px;\r\n      line-height: 2.5rem;\r\n    }\r\n  }\r\n  \r\n  @media (min-width: 830px) {\r\n    .typography-wrap {\r\n      font-size: 26px;\r\n    }\r\n  \r\n    .typography-wrap p {\r\n      font-size: 20px;\r\n    }\r\n  }\r\n  \r\n  @media (min-width: 960px) {\r\n    .typography-wrap {\r\n      font-size: 32px;\r\n    }\r\n  }\r\n  \r\n  .typography-wrap span {\r\n    color: var(--secondary-text);\r\n  }\r\n  \r\n  .typography-wrap p {\r\n    font-size: 20px;\r\n    font-weight: 200;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
